<template>
  <div class="mk-loading">
    <img class="mk-loading__spinner" src="../assets/spinner.svg"/>
  </div>
</template>

<script>
/**
 * Loader
 * @author David <david.prenninger@gmx.de>
 *
 * This component shows a generic spinner.
 */
export default {};
</script>

<style lang="scss" scoped>
  @import "@/assets/style/defaults.scss";

  .mk-loading {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 30;
    background-color: rgba($c_primary, 0.4);

    &__spinner {
      animation: spin 2s linear infinite;
      height: 40px;
    }

    @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
  }
</style>
